import ITable from './table'

export default {
  install(Vue) {
    Vue.component(ITable.name, ITable)
  }
}
